import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";

const SwaggerDocs = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const frontendURL = window.location.origin;
  const BASE_URL = process.env.REACT_APP_API_URL;
    
  useEffect(() => {
    if (!token) {
      navigate("/login"); 
    }
  }, [token, navigate]);

  return <SwaggerUI 
            url="/api_documentation.json"
            tryItOutEnabled={true} 
            requestInterceptor={(req) => {
                req.url = req.url.replace(frontendURL,BASE_URL);
                return req;
            }} 
        />
};

export default SwaggerDocs;
